import React, { useState } from 'react';
import api from './api';
import toast from 'react-hot-toast';

const Login = ({ setAuth }) => {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post('/auth/login', credentials);
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user)); // Store user info (id, role, name)
            setAuth(true);
            toast.success('Welcome back, Command.');
        } catch (err) {
            toast.error('Access Denied: Invalid Credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh',
            background: 'radial-gradient(circle at center, #1f2833 0%, #0b0c10 100%)'
        }}>
            <div className="login-container" style={{ width: '100%', maxWidth: '400px', padding: '50px' }}>
                <h1 style={{ color: '#66fcf1', textAlign: 'center', marginBottom: '40px', letterSpacing: '5px', textTransform: 'uppercase' }}>System Access</h1>
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="ADMIN EMAIL"
                        value={credentials.email}
                        onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                        required
                        style={{ textAlign: 'center', letterSpacing: '2px' }}
                    />
                    <input
                        type="password"
                        placeholder="PASSPHRASE"
                        value={credentials.password}
                        onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                        required
                        style={{ textAlign: 'center', letterSpacing: '2px' }}
                    />
                    <button disabled={loading} style={{ marginTop: '20px', width: '100%', padding: '15px', background: loading ? '#333' : 'rgba(102, 252, 241, 0.2)' }}>
                        {loading ? 'AUTHENTICATING...' : 'INITIATE SESSION'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
